import MasterDepartment from "./department";
export default MasterDepartment;